<ejs-richtexteditor #editor
    [placeholder]="label"
    (toolbarClick)="toolbarClick($event)" [(value)]='value' 
    (change)="change($event)"
    [toolbarSettings]="tools" height="{{height}}">
</ejs-richtexteditor>